export function exportDocumentToJson(data) {
    return JSON.stringify(data);
}
